import { TemplateCreateModel } from "../../models/templates/TemplateCreateModel";
import { inject, injectable } from "inversify";
import IAlertService from "../alert/IAlertService";
import { DiTokens } from "../diTokens";
import IErrorService from "../error/IErrorService";
import TemplateEditService from "./TemplateEditService";
import i18n from "@/i18n";
import { OperationRequestData } from "../../data/operationRequestData";
import { OperationsApi } from "../api/OperationsApi";
import { RequestsStates } from "../../data/enums/requestsStates";
import { ActionStateEnum } from "../../models/enums/operStateEnum";
import { TemplatesApi } from "../api/TemplatesApi";
import { TemplateData } from "../../data/templateData";
import { ContractsModel } from "../../models/contracts/contractsModel";
import { TemplatesStore } from "../../store/modules/templates";
import { OperationPropertyModel } from "../../models/operations/operationPropertyModel";

/**Сервис проведения операций */
@injectable()
export default class TemplateCreateService extends TemplateEditService {
  constructor(
    @inject(DiTokens.AlertService) public alertService: IAlertService,
    @inject(DiTokens.ErrorService) public errorService: IErrorService
  ) {
    super(alertService, errorService);
  }

  //public TemplatesStore!: TemplatesStore;

  /**
   * Инициализация операции
   * @param initData Данные для инициализации
   * */
  public async init(
    templateData: TemplateData | OperationRequestData,
    contracts: ContractsModel,
    templatesStore: TemplatesStore
  ): Promise<TemplateCreateModel> {
    try {
      //const template = await TemplatesApi.getTemplateAsync(templateData.Id);

      const declaration = await OperationsApi.getDeclarationAsync(
        parseInt((templateData as OperationRequestData).respondentCode),
        this.configStore.apiData.OperationCodeOfToOtherContractByCard, 
        this.configStore.apiData.OperationCodeOfToExt
      );

      const operationData = new TemplateCreateModel(
        declaration,
        null,
        null,
        contracts
      );
      
      operationData.RespondentCode = (templateData as OperationRequestData).respondentCode;

      this.TemplatesStore = templatesStore;

      //await operationData.setOperationFromRequest(template, false, true);

      return operationData;
    } catch (e) {
      await this.errorService.errorHandler(e, false, true, "");
      return null;
    }
  }

  public async prepare(
    model: TemplateCreateModel
  ): Promise<TemplateCreateModel> {
    try {
      const ordOperation: OperationRequestData = model.createOperationRequest();
      const ord: OperationRequestData = await TemplatesApi.saveTemplateByOperationAsync(
        ordOperation
      );
      model.setOperationFromRequest(ord, true);
      model.OperationId = ord.operationId;
      model._actionState = ActionStateEnum.Confirm;
      model._isNeedConfirm = ord.needConfirm;
      model.IsNeedInfoBeforeExecute =
        ord.needInfoBeforeExecute || !ord.needConfirm;
      if (!model._isNeedConfirm)
        model = (await this.analyzeState(model, ord)) as TemplateCreateModel;
    } catch (e) {
      model.ActionStateText = e.message;
      await this.errorService.errorHandler(e, false, true, "");
    }
    return model;
  }

  public async execute(
    model: TemplateCreateModel
  ): Promise<TemplateCreateModel> {
    try {
      model.ActionStateText = "";
      const ordOperation: OperationRequestData = await model.createOperationRequest();
      ordOperation.verificationCode = model.VerifyCode;
      const ord: OperationRequestData = await TemplatesApi.saveTemplateByOperationAsync(
        ordOperation
      );
      model.RequestState = ord.requestState;
      model = (await this.analyzeState(model, ord)) as TemplateCreateModel;
    } catch (e) {
      model.ActionStateText = e.message;
      await this.errorService.errorHandler(e, false, true, "");
    }
    return model;
  }

  /**
   * Следующий шаг операции
   */
  public async nextStep(model: TemplateCreateModel): Promise<TemplateCreateModel> {
    if (model.IsInit) {
      if (model.SelectedPeriod !== model.Periods[0]) {
        if (!model.NextDate || (model.NextDate <= model.DateToday)) {
          this.alertService.error(
            i18n.t("main.templates.errors.noDateToday").toString()
          );
          return model;
        }
      }
      model = (await this.prepare(model)) as TemplateCreateModel;
    } else if (model.IsConfirm) {
      model = (await this.execute(model)) as TemplateCreateModel;
    }
    return model;
  }

  /**
   * Действия после проведения операции
   */
  public async afterExecute(model: TemplateCreateModel): Promise<void> {
    await this.TemplatesStore.fetchTemplates();
    this.alertService.success(i18n.t("main.templates.successSave").toString());
  }
}
